import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home/Home';
import Dashboard from './pages/Dashboard';
import LoggedInLayout from './pages/LoggedInLayout';
import Ranking from './pages/Ranking';
import Stats from './pages/Stats';
import Settings from './pages/Settings';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Redirector from './pages/Redirector';
import Training from './pages/Training/Training';
import SessionView from './pages/Training/SessionView';
import { LanguageProvider } from './context/LanguageContext';
import AnimatedRoutes from './components/AnimatedRoutes';

const App: React.FC = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 0,                    // Always fetch fresh data, ok, testing purposes
        gcTime: 30 * 60 * 1000,          // Keep in memory for 30min offline (formerly cacheTime)
        refetchOnWindowFocus: true,      // Refetch when user returns
        refetchOnReconnect: true,        // Refetch when internet reconnects
        retry: 2,                        // Retry failed requests
      },
    },
  });

  return (
    <LanguageProvider>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/login" element={<Home />} />
          <Route path="*" element={<AnimatedRoutes />} />
        </Routes>
      </QueryClientProvider>
    </LanguageProvider>
  );
};

export default App;
